<div>
  <form [formGroup]="form" [attr.autocomplete]="'off'">
    @for (group of tilvalgGroups; track group; let i = $index) {
      <div formArrayName="tilvalgGroups" class="margin-top">
        <div class="form-row">
          <label class="form-headline">{{ group.name }}</label>
          <mat-radio-group formControlName="{{ i }}">
            @for (tilvalg of group.tilvalg; track tilvalg) {
              <mat-radio-button [disabled]="isDisabled(tilvalg)" [value]="tilvalg.tilvalgnr">
                {{ tilvalg.name }}
              </mat-radio-button>
            }
          </mat-radio-group>
        </div>
      </div>
    }
  </form>
</div>
